import React, { memo } from 'react';
import PropTypes from 'prop-types';
import AllowedStatesListComponent from './AllowedStatesListComponent';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';

const AllowedStateListCard = ({ localState, onEdit, onRemove, dispatch, changed }) => {
  const getPagedAllowedStates = () => {
    let pager = localState.pager;
    var begin = pager.page * pager.pageSize;
    var end = begin + pager.pageSize;
    const list = localState.documentTypeWithAllowedStates.allowedStates ? [...localState.documentTypeWithAllowedStates.allowedStates] : [];
    return list.slice(begin, end);
  };

  return (
    <CardNoResultsWrapper content={getPagedAllowedStates()}>
      <AllowedStatesListComponent
        allowedStates={getPagedAllowedStates()}
        userGroups={localState.userGroups}
        dispatch={dispatch}
        onEdit={onEdit}
        onRemove={onRemove}
        changedAllowedStatesPermissions={localState.changedAllowedStatesPermissions}
        changed={changed}
      />
    </CardNoResultsWrapper>
  );
};

AllowedStateListCard.propTypes = {
  localState: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  changed: PropTypes.bool
};

export default memo(AllowedStateListCard);
